import * as userActions from "../actions/userActions";
import { updateObject } from "../../utils/util";
import produce from "immer";

const initialState = {
  name: "",
  lastName: "",
  docType: "",
  docNumber: "",
  age: "",
  email: "",
  phone: "",
  address: "",
  contracts: [],
  beneficiaries: [],
  expireSession: "",
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case userActions.CLEAR_USER:
      return initialState;
    case userActions.ADD_MAIN_DATA:
    case userActions.ADD_PH_ADR:
      return updateObject(state, { ...action.user });
    case userActions.ADD_CONTRACTS:
      return produce(state, draftState => {
        action.user.contracts.forEach(item => {
          //const itemFound = state.contracts.find(itemState => itemState.number === item.number);
          //if(itemFound === undefined && undefined !== item.number){
            draftState.contracts.push(item);
          //}
        });
      });
    case userActions.ADD_BENFICIARIES:
      return produce(state, draftState => {
        action.user.beneficiaries.forEach(item => {
          draftState.beneficiaries.push(item);
        })
      });
    case userActions.ADD_BILLS:
      return produce(state, draftState => {
        draftState.contracts[action.user.index].requested = true;
        action.user.bills.forEach(item => {
          if(draftState.contracts[action.user.index].bills.filter(item2 => {
            return item2.numero === item.numero
          }).length===0){
            draftState.contracts[action.user.index].bills.push(item);
          }
        });
      });
    case userActions.CLEAR_CONTRACTS:
      return produce(state, draftState => {
        draftState.contracts = initialState.contracts;
      });
    case userActions.CLEAR_BILLS:
      return produce(state, draftState => {
        draftState.contracts[action.user.index].bills = initialState.bills;
      });
    case userActions.CLEAR_BENFICIARIES:
      return produce(state, draftState => {
        draftState.beneficiaries = initialState.beneficiaries;
      });
    case userActions.UPDATE_EXPIRE_SESSION:
      return updateObject(state, { ...action.user, expireSession: action.user.expireSession });
    case userActions.UPDATE_CONTRACT_BALANCE:
      return produce(state, draftState => {
          draftState.contracts = action.contracts
      });
    case userActions.SET_CONTRACT_BALANCE:
      return produce(state, draftState => {
        draftState.contracts = state.contracts.map((item) => {
            if (action.payload.number === item.number) {
              return {
                ...item,
                balance: action.payload.balance
              }
            }
            return item;
          })
      });
    case userActions.UPDATE_EMAIL_USER:
      return  updateObject(state, { ...action.user, email: action.user.email }); 

     case userActions.ADD_P_PH:
        return produce(state, draftState => {
          draftState.contracts = state.contracts.map((item) => {
            if (action.user.contractNumber === item.number) {
               return {...item, personalPhone: action.user.phone}
            }
            return item; 
          })
        });
    case userActions.ADD_C_PH:
          return produce(state, draftState => {
            draftState.contracts = state.contracts.map((item) => {
              if (action.user.contractNumber === item.number) {
                 return {...item, cellPhone: action.user.phone}
              }
              return item; 
            })
          }); 
    case userActions.ADD_P_EM:
          return produce(state, draftState => {
            draftState.contracts = state.contracts.map((item) => {
              if (action.user.contractNumber === item.number) {
                 return {...item, personalEmail: action.user.email}
              }
              return item; 
            })
          }); 
    default:
      return state;
  }
}
